// extracted by mini-css-extract-plugin
export var content = "gZM3H";
export var ctaButton = "TPTYG";
export var ctas = "_38yv4";
export var image = "_9mHr9";
export var paragraph = "LOuWa";
export var title = "DlbN-";